var $ = jQuery;

function isOnScreen(elem) {
	// if the element doesn't exist, abort
	if( elem.length == 0 ) {
		return;
	}
	var $window = jQuery(window)
	var viewport_top = $window.scrollTop()
	var viewport_height = $window.height()
	var viewport_bottom = viewport_top + viewport_height
	var $elem = jQuery(elem)
	var top = $elem.offset().top
	var height = $elem.height()
	var bottom = top + height

	return (top >= viewport_top && top < viewport_bottom) ||
	(bottom > viewport_top && bottom <= viewport_bottom) ||
	(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}

$(document).ready(function(){    

    if( isOnScreen($(".non-sticky-atc-button").eq(0)) ||
     	isOnScreen($(".non-sticky-atc-button").eq(1)) || 
     	isOnScreen($(".non-sticky-atc-button").eq(2)) ||
     	isOnScreen($(".non-sticky-atc-button").eq(3)) || 
		 isOnScreen($("#footer")) )   {
    	$(".sticky-atc-button").fadeOut(100);

  	} else {
    	$(".sticky-atc-button").fadeIn(100);
  	}
  
  	$(window).on('scroll',function(){
    	if( isOnScreen($(".non-sticky-atc-button").eq(0)) ||
	     	isOnScreen($(".non-sticky-atc-button").eq(1)) || 
	     	isOnScreen($(".non-sticky-atc-button").eq(2)) ||
	     	isOnScreen($(".non-sticky-atc-button").eq(3)) || 
			isOnScreen($("#footer")) )   {
      		$(".sticky-atc-button").fadeOut(10);
      
    	} else {
     		$(".sticky-atc-button").fadeIn(10);
    	}
  	});	 

    let headerHeight = $('.header__wrapper').height();
    let annoincementBarHeight = $('.announcement-bar__wrapper').height();
    let totalHeight = headerHeight + annoincementBarHeight;

    /* scroll to target */
    jQuery('.scrollTo').click(function(e) {
        var jump = jQuery(this).attr('href');
        var new_position = jQuery(jump).offset();
        var scroll = -totalHeight;
        jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800, function(){
            var new_position = jQuery(jump).offset();
            jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800);
        });
        e.preventDefault();
    });

    
     /* product slider start */
     if($('.product-banner__main').length) {
        $('.product-banner__main').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            draggable: false,
            asNavFor: '.product-banner__nav',
            prevArrow: '<button type="button" class="prev-arrow cus-slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0617/3750/0896/files/icon-arrow-left.svg?v=1695217411"></button>',
		    nextArrow: '<button type="button" class="next-arrow cus-slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0617/3750/0896/files/icon-arrow-right.svg?v=1695217411"></button>',
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        arrows: false,
                    }
                }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
            ]
            
        });
    }
    if($('.product-banner__nav').length) {
        $('.product-banner__nav').slick({
            slidesToShow: 5,
            slidesToScroll: 5,
            asNavFor: '.product-banner__main',
            dots: false,
            arrows: true,
            centerMode: false,
            focusOnSelect: true,
            prevArrow: '<button type="button" class="prev-arrow cus-slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0617/3750/0896/files/icon-arrow-left.svg?v=1695217411"></button>',
		    nextArrow: '<button type="button" class="next-arrow cus-slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0617/3750/0896/files/icon-arrow-right.svg?v=1695217411"></button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        vertical: false,
                        slidesToShow: 5,
                        slidesToScroll: 5
                    },
                    breakpoint: 767,
                    settings: {
                        arrows: true,
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
            ]
        });
    }
    /* product slider END */    


    $(window).on("resize", function (e) {
        checkScreenSize();
    });

    checkScreenSize();
    
    function checkScreenSize(){        
        var newWindowWidth = $(window).width();
        if (newWindowWidth < 768) {
            if($('.navigation-section__nav-link').length){
                $('.navigation-section__nav-link').slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: true,
                    draggable: true,
                    infinite: false, 
                    variableWidth: true,
                    prevArrow: '<button type="button" class="prev-arrow cus-slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0617/3750/0896/files/icon-arrow-left.svg?v=1695217411"></button>',
                    nextArrow: '<button type="button" class="next-arrow cus-slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0617/3750/0896/files/icon-arrow-right.svg?v=1695217411"></button>',
                })
            }
        }  
    }


    /* easter-sale-strip__slider Start */
    if($('.order-delivery-info-slider').length) {
        $('.order-delivery-info-slider').slick({
            dots: false,
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,            
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2.5,
                        slidesToScroll: 1,
                        speed: 8000,
                        autoplay: true,
                        autoplaySpeed: 0,
                        cssEase: 'linear',
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1.5,
                        slidesToScroll: 1,
                        speed: 8000,
                        autoplay: true,
                        autoplaySpeed: 0,
                        cssEase: 'linear'
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        speed: 8000,
                        autoplay: true,
                        autoplaySpeed: 0,
                        cssEase: 'linear'
                    }
                }
            ]
        });
    }
    /* easter-sale-strip__slider End */    

    /* Emotive Recommendations Slider Start */
    // if($('.emotive-recommendations-slider').length) {
    //     $('.emotive-recommendations-slider').slick({
    //         dots: false,
    //         arrows: false,
    //         slidesToShow: 5,
    //         slidesToScroll: 1,
    //         infinite: false,                        
    //         rows: 1,            
    //         prevArrow: '<button type="button" class="prev-arrow cus-slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0617/3750/0896/files/icon-arrow-left.svg?v=1695217411"></button>',
	// 	    nextArrow: '<button type="button" class="next-arrow cus-slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0617/3750/0896/files/icon-arrow-right.svg?v=1695217411"></button>',
    //         responsive: [
    //             {
    //                 breakpoint: 767,
    //                 settings: {
    //                     slidesToShow: 2,
    //                     slidesToScroll: 1,
    //                     rows: 2,
    //                     infinite: false,
    //                     arrows: true,
	// 	                speed: 300                        
    //                 }
    //             },
    //             {
    //                 breakpoint: 575,
    //                 settings: {
    //                     slidesToShow: 2,
    //                     slidesToScroll: 1,
    //                     rows: 2,
    //                     infinite: false,
    //                     arrows: true,
	// 	                speed: 300,
    //                 }
    //             }
    //         ]
    //     });
    // }
    /* Emotive Recommendations Slider End */

    /* Partnered Products Slider Start */

    var existCondition = setInterval(function() {
        if ($('.partnered-products-slider').length) {
           clearInterval(existCondition);
           partneredslider()
        }
       }, 50); // check every 100ms

function partneredslider(){
    if($('.partnered-products-slider').length) {
        $('.partnered-products-slider').slick({
            dots: false,
            arrows: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: false,                        
            prevArrow: '<button type="button" class="prev-arrow cus-slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0617/3750/0896/files/icon-arrow-left.svg?v=1695217411"></button>',
		    nextArrow: '<button type="button" class="next-arrow cus-slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0617/3750/0896/files/icon-arrow-right.svg?v=1695217411"></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: false,
                        arrows: true,
		                speed: 300                        
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        arrows: true,
		                speed: 300,
                    }
                }
            ]
        });
    }
}
    /* Partnered Products Slider End */

    /* Emotive Customer Reviews Slider Start */
    if($('.emotive-customer-reviews-slider').length) {
        $('.emotive-customer-reviews-slider').slick({
            dots: false,
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,                        
            prevArrow: '<button type="button" class="prev-arrow cus-slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0617/3750/0896/files/icon-arrow-left.svg?v=1695217411"></button>',
		    nextArrow: '<button type="button" class="next-arrow cus-slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0617/3750/0896/files/icon-arrow-right.svg?v=1695217411"></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
		                speed: 300                        
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        arrows: true,
		                speed: 300,
                    }
                }
            ]
        });
    }
    /* Emotive Customer Reviews Slider End */

    $('.emotive-recommendations__slider-content h6').matchHeight({
        byRow: true,
    });
    $('.partnered-products__desc h6').matchHeight({
        byRow: true,
    });
    $('.features-product-new__box h4').matchHeight({
        byRow: true,
    });
    $('.partnered-products__desc h6').matchHeight({
        byRow: true,
    });

    // Image zoom plugin code	
    $('.imageZoomExtra').each(function(){
		$(this).imageZoom();
	});   
    $("[data-fancybox='gallery']").fancybox({
        Images: {
            initialSize: "max",
        }
    });   

});

// $(window).on("load",function(e){
//     if ($(window).width() < 767) {
//         var textContainer = $(".breadcrumbElipsis");
//         var textContainerwords = textContainer.text().trim().split(/\s+/);
//         var textCount = textContainerwords.length;
//         if(textCount > 2){
//             textContainer.text(textContainer.text().split(' ').slice(0, 2).join(' ') + '...');
//         }
//     };
// });

// Tab Content js Start here
function openCity(evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("emotive-recommendations__tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("emotive-recommendations__tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
    // $('.emotive-recommendations-slider').slick('setPosition');
    $('.emotive-recommendations__slider-content h6').matchHeight({
        byRow: true,
    });
}
// Tab Content js End here

// images After Befor js Start here
const container = document.querySelector('.container-wrp-cus');
document.querySelector('.slider').addEventListener('input', (e) => {
  container.style.setProperty('--position', `${e.target.value}%`);
})
// images After Befor js End here

    $(document).on('change','.swatches__form--input', function() {
    $('.swatches__container').each(function () {
    var vkr= $(this).find('.swatches__form--input:checked').val();    
  if(vkr == "Custom")
  {
    $(this).hide()  
  }else{
      $(this).show()  
  }
})
})